<template>
  <div class="sub-container">
    <v-card class="ml-3 mt-0" color="#433876" variant="flat" height="60px">
      <v-card-actions>
        <span class="mt-0 ml-2 head-sub-text">
          <v-icon class="mx-2">mdi-account</v-icon>Users</span>
        <v-spacer />

        <v-btn color="purple" variant="flat" class="btn-text mr-3" size="small" :to="{ name: 'addUser' }">
          <span class="btn-text"><v-icon class="mx-2">mdi-file-plus</v-icon>Add User</span>
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-card-actions class="ml-8">
      <v-spacer />
      <div class="search-field">
        <v-text-field v-model="search" label="Search" prepend-inner-icon="mdi-magnify" variant="outlined"
          density="compact" hide-details single-line />
      </div>
    </v-card-actions>

    <v-card variant="flat" class="ml-3">
      <v-data-table :items="emails.length > 0 ? emails : []" :headers="headers" item-value="id" :search="search"
        :hide-default-footer="false" :items-per-page="pagination ? pagination.page_size : 20">
        <template #[`item.username`]="{ item }">
          {{
            item.raw.username !== "" ? item.raw.username : "N/A "
          }}
        </template>

        <template #[`item.is_admin`]="{ item }">
          <v-chip :color="getColor(item.raw.is_admin)" variant="flat" size="x-small">
            <span class="chip-text">{{
              item.raw.is_admin ? "admin" : "user"
            }}</span>
          </v-chip>
        </template>

        <template #[`item.actions`]="{ item }">
          <!-- <v-menu>
            <template v-slot:activator="{ props }">
              <v-icon v-bind="props"> mdi-dots-vertical</v-icon>
            </template>

<v-list>
  <v-list-item class="mt-n3" :to="{ name: 'edituser', params: { id: item.raw.id } }">
    <v-list-item-title class="list-title">Edit</v-list-item-title>
  </v-list-item>

  <v-list-item class="mt-n3" @click="deleteItem(item.raw.id)">
    <v-list-item-title class="list-title">Delete</v-list-item-title>
  </v-list-item>
</v-list>
</v-menu> -->
          <div class="d-flex align-center">
            <v-tooltip location="bottom" text="Edit">
              <template #activator="{ props: tooltipProps }">
                <v-icon v-bind="tooltipProps" class="cursor-pointer text-primary mx-8 ml-n2" @click="
                  $router.push({
                    name: 'edituser',
                    params: { id: item.raw.id },
                  })
                  ">
                  mdi-pencil
                </v-icon>
              </template>
            </v-tooltip>

            <v-tooltip location="bottom" text="Edit">
              <template #activator="{ props: tooltipProps }">
                <v-icon v-bind="tooltipProps" class="cursor-pointer text-error mx-2 ml-n2"
                  @click="deleteItem(item.raw.id)">
                  mdi-delete
                </v-icon>
              </template>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
      <v-card-actions class="mt-n12">
        <v-spacer class="" />

        <v-card class=" mt-n3" color="#fffff" variant="flat">

          <PaginationControls :current-page="pagination ? pagination.current_page : 0" :total-pages="pagination ? pagination.total_pages : 0"
            @page-changed="fetchSubscribers" />
        </v-card>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="loaderState" max-width="500">
      <v-card>
        <v-card-actions><v-spacer />Please Wait <v-spacer /></v-card-actions>
        <v-card-actions><v-spacer />
          <div class="ball"></div>
          <div class="ball"></div>
          <div class="ball"></div>
          <div class="ball"></div>
          <div class="ball"></div>

          <v-spacer />
        </v-card-actions>

        <v-progress-linear class="mx-2 mt-n3" color="teal" indeterminate></v-progress-linear>
        <v-card-actions></v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PaginationControls from "@/utils/PaginationControls.vue";
export default {
  name: "userActivity",
  beforeRouteEnter(to, from, next) {
    next((v) => {
      const data = {
        offset: undefined,
      };
      v.$store.dispatch("dashboard/getUsers", data);
    });
  },

  components: {
    PaginationControls,
  },

  data() {
    return {
      //   menu: false,
      selectedEndDate: null,
      selectedStartDate: null,
      date: null,

      offset: 0,
      dialog: true,
      groups: [],
      menu: false,
      menu2: false,
      menu3: false,
      search: "",
      isValid: false,
      loadingState: false,
      screenSize: "",
      oldValue: false,
      formData: {
        start_date: null,
        end_date: null,
        page: null,
      },

      selected: [],

      headers: [
        { title: "Email", key: "email" },

        {
          title: "Name",
          key: "username",
        },
        { title: "Company name", key: "company_name" },
        { title: "Role", key: "is_admin" },
        { title: "Actions", key: "actions" },
      ],
    };
  },

  computed: {
    emails() {
      return this.$store.getters["dashboard/dashboardGetters"]("users");
    },
    pagination() {
      return this.$store.getters["dashboard/dashboardGetters"]("pagination");
    },


    loaderState() {
      return this.$store.getters["email/emailGetters"]("loaderState");
    },

    formattedStartDate: {
      get() {
        return this.selectedStartDate;
      },
      set(value) {
        this.selectedStartDate = this.formatDate(value);
      },
    },
    formattedEndDate: {
      get() {
        return this.selectedEndDate;
      },
      set(value) {
        this.selectedEndDate = this.formatDate(value);
      },
    },
  },

  mounted() {
    this.checkScreenSize(); // Check screen size initially
    window.addEventListener("resize", this.checkScreenSize);
    this.getCurrentDate();
  },
  methods: {
    getColor(val) {
      if (val) return "#46c35f";
      else return "orange";
    },
    submitFilters() {
      // Reset page to 1
      this.formData.page = 1;
      (this.formData.start_date = this.formattedStartDate),
        (this.formData.end_date = this.formattedEndDate),
        // Dispatch the cleaned data
        this.$store.dispatch("dashboard/getActivity", this.formData);
    },
    clearFilters() {
      // Get current date
      this.formattedStartDate = null;
      this.formattedEndDate = null;
    },
    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      return d.toISOString().split("T")[0]; // Formats to YYYY-MM-DD
    },
    checkScreenSize() {
      const isSmallScreen = window.matchMedia("(max-width: 768px)").matches;
      this.screenSize = isSmallScreen ? "Small" : "Large";
    },
    addFilter(filterType) {
      // Toggle the show state for the selected filter
      if (filterType === "sent") {
        this.showSent = !this.showSent;
        this.formData.is_sent = this.showSent; // Set to the current toggle state
      } else if (filterType === "opened") {
        this.showOp = !this.showOp;
        this.formData.is_opened = this.showOp; // Set to the current toggle state
      } else if (filterType === "delivered") {
        this.showDel = !this.showDel;
        this.formData.is_delivered = this.showDel; // Set to the current toggle state
      } else if (filterType === "clicked") {
        this.showclicked = !this.showclicked;
        this.formData.is_clicked = this.showclicked; // Set to the current toggle state
      }
    },

    onPaginationChange() {
      // Update the offset state

      this.offset -= 10;
      this.$store.dispatch("dashboard/getUsers", this.offset);
    },

    onPaginationNextChange() {
      // Update the offset state

      this.offset -= 10;
      this.$store.dispatch("dashboard/getUsers", this.offset);
    },
    getCurrentDate() {
      const now = new Date();

      // First day of the month (YYYY-MM-DD format)
      const firstDay = `${now.getFullYear()}-${String(
        now.getMonth() + 1
      ).padStart(2, "0")}-01`;

      // Last day of the month (YYYY-MM-DD format)
      const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      const formattedLastDay = `${lastDay.getFullYear()}-${String(
        lastDay.getMonth() + 1
      ).padStart(2, "0")}-${String(lastDay.getDate()).padStart(2, "0")}`;
      this.selectedStartDate = firstDay;
      this.selectedEndDate = formattedLastDay;
    },
  },

  watch: {
    loaderState: {
      handler: function (newValue, oldValue) {
        this.oldValue = oldValue;
        this.loadingState = newValue;
      },
      immediate: true,
    },
  },
};
</script>

<style>
@import url("../../emails/emailStyle.css");
</style>
